var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgKingBed = function SvgKingBed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 19H4L3.5 16H5.5L5 19ZM20 19H19L18.5 16H20.5L20 19Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00002 6.59999C5.77911 6.59999 5.60002 6.77908 5.60002 6.99999V10.4H11.4V6.59999H6.00002ZM12.6 6.59999V10.4H18.4V6.99999C18.4 6.77908 18.2209 6.59999 18 6.59999H12.6ZM19.6 10.4V6.99999C19.6 6.11634 18.8837 5.39999 18 5.39999H6.00002C5.11637 5.39999 4.40002 6.11634 4.40002 6.99999V10.4H4.00002C3.11637 10.4 2.40002 11.1163 2.40002 12V16.6H21.6V12C21.6 11.1163 20.8837 10.4 20 10.4H19.6ZM4.00002 11.6C3.77911 11.6 3.60002 11.7791 3.60002 12V15.4H20.4V12C20.4 11.7791 20.2209 11.6 20 11.6H4.00002Z"
  })));
};
export default SvgKingBed;